import React from "react";
import CDRsList from "./sections/CDRsList";
import NewAndBetterConcept from "./sections/newAndBetterConcept";
import WrongInvoices from "./sections/wrongInvoices";
import Letsgo from "../connectors/letsgo";
import "./telecom.scss";

function Telecom() {
  return (
    <div className="container-telecom">
      <div className="section-new-and-better-concept">
        <NewAndBetterConcept />
      </div>
      <div className="section-wrong-invoices">
        <WrongInvoices />
      </div>
      <div className="section-CDRs-list">
        <CDRsList />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  );
}

export default Telecom;
